import { BaseEntity } from '@base-entities';
import { CommonTransformer } from '@base-transformers';
import { IBaseTransformerRepository } from '@base-repositories';

export function makeCommonTransformer<E extends BaseEntity = BaseEntity>(): IBaseTransformerRepository<E> {
  return new CommonTransformer<E>();
}
